<script lang="ts">
	import { setContext, onDestroy } from 'svelte';
	import { writable } from 'svelte/store';
	import { WizardContainer, WizardContent } from '@Shelly/shelly-design-system/index';

	export let device: any = null;
	export let settings: any = {};
	export let roomBoundaries: any[] = [];
	export let zonesData: any[] = [];
	export let currentStepIdx: number = 0;
	export let steps: { title: string; component: any; skippable?: boolean; nextLabel?: string }[] = [];

	// Context available to all step components
	const radarSetupContext = writable({
		device,
		settings,
		roomBoundaries,
		zonesData,
		sensorConfigured: false,
	});
	setContext('radarSetupContext', radarSetupContext);

	$: radarSetupContext.update((ctx) => ({ ...ctx, device, settings, roomBoundaries, zonesData }));

	onDestroy(() => {
		radarSetupContext.set({ device, settings, roomBoundaries, zonesData, sensorConfigured: false });
	});
</script>

<WizardContainer activeStepIndex={currentStepIdx} adaptiveHeight fullHeight>
	{#each steps as step, i (i)}
		<WizardContent active={currentStepIdx === i}>
			<!-- Forward the 'next' event from step components (e.g. ConfigStep after save) -->
			<svelte:component this={step.component} on:next />
		</WizardContent>
	{/each}
</WizardContainer>
